import { Card, CardBody, Skeleton } from '@heroui/react';

export function TaskSubmitRecordCardSkeleton({
  count = 1,
}: {
  count?: number;
}) {
  return Array.from(Array(count).keys()).map((i) => (
    <Card key={i} shadow="none">
      <CardBody className="flex flex-row items-center gap-4">
        <Skeleton className="size-[48px] rounded-lg" />
        <div className="flex flex-1 items-center gap-3">
          <div className="flex-1">
            <Skeleton className="h-5 w-3/4 rounded-lg" />

            <Skeleton className="mt-2 h-4 w-1/4 rounded-lg" />
          </div>
        </div>
        <Skeleton className="h-6 w-16 rounded-full" />
      </CardBody>
    </Card>
  ));
}
